export class FailedToRequestSttError extends Error {
  constructor() {
    super('An error occurred while requesting the text. Please try again later.')
    Object.setPrototypeOf(this, FailedToRequestSttError.prototype)
  }
}
